var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.846,
    height: 57.123,
    viewBox: "0 0 13.846 57.123"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(-3796.229 329.292) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(272.169 3797.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-9.479-170.708l9.279-6-9.279-6Z",
    transform: "translate(56.402 182.716)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 46.924,
    transform: "translate(0 6.004)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMTMuODQ2IgogIGhlaWdodD0iNTcuMTIzIgogIHZpZXdCb3g9IjAgMCAxMy44NDYgNTcuMTIzIgo+CiAgPGcKICAgIGlkPSJHcm91cF8zMjgiCiAgICBkYXRhLW5hbWU9Ikdyb3VwIDMyOCIKICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNzk2LjIyOSAzMjkuMjkyKSByb3RhdGUoLTkwKSIKICA+CiAgICA8ZwogICAgICBpZD0iR3JvdXBfMTAiCiAgICAgIGRhdGEtbmFtZT0iR3JvdXAgMTAiCiAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3Mi4xNjkgMzc5Ny4xNDgpIgogICAgPgogICAgICA8cGF0aAogICAgICAgIGlkPSJQYXRoXzI3IgogICAgICAgIGRhdGEtbmFtZT0iUGF0aCAyNyIKICAgICAgICBkPSJNLTkuNDc5LTE3MC43MDhsOS4yNzktNi05LjI3OS02WiIKICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1Ni40MDIgMTgyLjcxNikiCiAgICAgICAgZmlsbD0ibm9uZSIKICAgICAgICBzdHJva2U9IiNmZmYiCiAgICAgICAgc3Ryb2tlLXdpZHRoPSIxIgogICAgICAvPgogICAgICA8bGluZQogICAgICAgIGlkPSJMaW5lXzEiCiAgICAgICAgZGF0YS1uYW1lPSJMaW5lIDEiCiAgICAgICAgeDI9IjQ2LjkyNCIKICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDYuMDA0KSIKICAgICAgICBmaWxsPSJub25lIgogICAgICAgIHN0cm9rZT0iI2ZmZiIKICAgICAgICBzdHJva2Utd2lkdGg9IjEiCiAgICAgIC8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { SvgArrowUp as ReactComponent };